import React, { createContext, useContext } from 'react';
import {
  CloudbuildTriggerApi,
  LocationResolver,
  ProjectNameResolver,
} from './types';

interface TriggerContextProps {
  api: CloudbuildTriggerApi;
  projectNameResolver: ProjectNameResolver;
  locationResolver: LocationResolver;
}

const TriggerContext = createContext<TriggerContextProps | undefined>(
  undefined,
);

export const useTriggerContext = () => {
  const context = useContext(TriggerContext);
  if (!context) {
    throw new Error('TriggerContext must be used within a TriggerProvider');
  }
  return context;
};

export const TriggerProvider: React.FC<
  TriggerContextProps & { children: React.ReactNode }
> = ({ api, projectNameResolver, locationResolver, children }) => (
  <TriggerContext.Provider
    value={{ api, projectNameResolver, locationResolver }}
  >
    {children}
  </TriggerContext.Provider>
);
